unit View.Plano_Contas1.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewPlano_Contas1Edit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbclasse: TLabel;
    edclasse: TDBEdit;
    lbpeso_ideal: TLabel;
    edpeso_ideal: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientPlano_Contas1Get: TXDataWebClient;
    XDataClientPlano_Contas1Delete: TXDataWebClient;
    Plano_Contas1Dataset: TXDataWebDataSet;
    Plano_Contas1Datasetid: TIntegerField;
    Plano_Contas1Datasetaliado_id: TIntegerField;
    Plano_Contas1Datasetdata_base_id: TIntegerField;
    Plano_Contas1Datasetnome: TStringField;
    Plano_Contas1Datasetclasse: TStringField;
    Plano_Contas1Datasetpeso_ideal: TFloatField;
    Plano_Contas1Datasetcodigo_interno: TIntegerField;
    Plano_Contas1Datasetexcluido: TBooleanField;
    Plano_Contas1Datasetinclusao: TDateTimeField;
    Plano_Contas1Datasetalteracao: TDateTimeField;
    Plano_Contas1Datasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientPlano_Contas1GetLoad(Response: TXDataClientResponse);
    procedure XDataClientPlano_Contas1DeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientPlano_Contas1DeleteError(Error: TXDataClientError);
    procedure Plano_Contas1DatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewPlano_Contas1Edit: TFViewPlano_Contas1Edit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewPlano_Contas1Edit }

procedure TFViewPlano_Contas1Edit.btSaveClick(Sender: TObject);
begin
  if Plano_Contas1Dataset.State in dsEditModes then
  begin
        Plano_Contas1Dataset.Post;
    Plano_Contas1Dataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewPlano_Contas1Edit.btDeleteClick(Sender: TObject);
begin
  if Plano_Contas1Dataset.State in dsEditModes then
    Plano_Contas1Dataset.Post;
  XDataClientPlano_Contas1Delete.Delete(Plano_Contas1Dataset.EntitySetName,
    TJSObject(Plano_Contas1Dataset.CurrentData));
end;


class function TFViewPlano_Contas1Edit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewPlano_Contas1Edit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewPlano_Contas1Edit.InsertEntity;
begin
  Plano_Contas1Dataset.Close;
  Plano_Contas1Dataset.SetJsonData('{}');
  Plano_Contas1Dataset.Open;
  Plano_Contas1Dataset.Insert;
end;

class function TFViewPlano_Contas1Edit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewPlano_Contas1Edit(AForm).FInserting := AInserting;
    TFViewPlano_Contas1Edit(AForm).FId := AId;
    TFViewPlano_Contas1Edit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewPlano_Contas1Edit(AForm).InsertEntity
    else
      TFViewPlano_Contas1Edit(AForm).LoadEntity;
    TFViewPlano_Contas1Edit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewPlano_Contas1Edit, AElementID, Result, @AfterCreate);
end;

procedure TFViewPlano_Contas1Edit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Plano_Contas1Dataset.Connection.Model.DefaultSchema.FindEntityType(
      Plano_Contas1Dataset.EntitySetName
    )
  );
  XDataClientPlano_Contas1Get.Get(Plano_Contas1Dataset.EntitySetName, QueryString, FId);
end;

procedure TFViewPlano_Contas1Edit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewPlano_Contas1Edit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewPlano_Contas1Edit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewPlano_Contas1Edit.XDataClientPlano_Contas1GetLoad(Response: TXDataClientResponse);
begin
  Plano_Contas1Dataset.Close;
  Plano_Contas1Dataset.SetJsonData(Response.Result);
  Plano_Contas1Dataset.Open;
  
  Plano_Contas1Dataset.Edit;  
end;

procedure TFViewPlano_Contas1Edit.XDataClientPlano_Contas1DeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewPlano_Contas1Edit.XDataClientPlano_Contas1DeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewPlano_Contas1Edit.Plano_Contas1DatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewPlano_Contas1Edit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewPlano_Contas1Edit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.plano_contas1.form.message');
  lbMessage := TLabel.Create('view.plano_contas1.form.message.label');
  btCloseMessage := TButton.Create('view.plano_contas1.form.message.button');
  btCancel := TButton.Create('view.plano_contas1.form.btBack');
  btSave := TButton.Create('view.plano_contas1.form.btSave');
  btDelete := TButton.Create('view.plano_contas1.form.btDelete');
  lbid := TLabel.Create('view.plano_contas1.form.lbid');
  edid := TDBEdit.Create('view.plano_contas1.form.edid');
  lbaliado_id := TLabel.Create('view.plano_contas1.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.plano_contas1.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.plano_contas1.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.plano_contas1.form.eddata_base_id');
  lbnome := TLabel.Create('view.plano_contas1.form.lbnome');
  ednome := TDBEdit.Create('view.plano_contas1.form.ednome');
  lbclasse := TLabel.Create('view.plano_contas1.form.lbclasse');
  edclasse := TDBEdit.Create('view.plano_contas1.form.edclasse');
  lbpeso_ideal := TLabel.Create('view.plano_contas1.form.lbpeso_ideal');
  edpeso_ideal := TDBEdit.Create('view.plano_contas1.form.edpeso_ideal');
  lbcodigo_interno := TLabel.Create('view.plano_contas1.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.plano_contas1.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.plano_contas1.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.plano_contas1.form.edexcluido');
  lbinclusao := TLabel.Create('view.plano_contas1.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.plano_contas1.form.edinclusao');
  lbalteracao := TLabel.Create('view.plano_contas1.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.plano_contas1.form.edalteracao');
  lbexclusao := TLabel.Create('view.plano_contas1.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.plano_contas1.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Plano_Contas1Dataset := TXDataWebDataSet.Create(Self);
  Plano_Contas1Datasetid := TIntegerField.Create(Self);
  Plano_Contas1Datasetaliado_id := TIntegerField.Create(Self);
  Plano_Contas1Datasetdata_base_id := TIntegerField.Create(Self);
  Plano_Contas1Datasetnome := TStringField.Create(Self);
  Plano_Contas1Datasetclasse := TStringField.Create(Self);
  Plano_Contas1Datasetpeso_ideal := TFloatField.Create(Self);
  Plano_Contas1Datasetcodigo_interno := TIntegerField.Create(Self);
  Plano_Contas1Datasetexcluido := TBooleanField.Create(Self);
  Plano_Contas1Datasetinclusao := TDateTimeField.Create(Self);
  Plano_Contas1Datasetalteracao := TDateTimeField.Create(Self);
  Plano_Contas1Datasetexclusao := TDateTimeField.Create(Self);
  XDataClientPlano_Contas1Get := TXDataWebClient.Create(Self);
  XDataClientPlano_Contas1Delete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbclasse.BeforeLoadDFMValues;
  edclasse.BeforeLoadDFMValues;
  lbpeso_ideal.BeforeLoadDFMValues;
  edpeso_ideal.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Plano_Contas1Dataset.BeforeLoadDFMValues;
  Plano_Contas1Datasetid.BeforeLoadDFMValues;
  Plano_Contas1Datasetaliado_id.BeforeLoadDFMValues;
  Plano_Contas1Datasetdata_base_id.BeforeLoadDFMValues;
  Plano_Contas1Datasetnome.BeforeLoadDFMValues;
  Plano_Contas1Datasetclasse.BeforeLoadDFMValues;
  Plano_Contas1Datasetpeso_ideal.BeforeLoadDFMValues;
  Plano_Contas1Datasetcodigo_interno.BeforeLoadDFMValues;
  Plano_Contas1Datasetexcluido.BeforeLoadDFMValues;
  Plano_Contas1Datasetinclusao.BeforeLoadDFMValues;
  Plano_Contas1Datasetalteracao.BeforeLoadDFMValues;
  Plano_Contas1Datasetexclusao.BeforeLoadDFMValues;
  XDataClientPlano_Contas1Get.BeforeLoadDFMValues;
  XDataClientPlano_Contas1Delete.BeforeLoadDFMValues;
  try
    Name := 'FViewPlano_Contas1Edit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 562;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 502;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 502;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 502;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 273;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 270;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 9;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbclasse.SetParentComponent(Self);
    lbclasse.Name := 'lbclasse';
    lbclasse.Left := 24;
    lbclasse.Top := 300;
    lbclasse.Width := 14;
    lbclasse.Height := 13;
    lbclasse.Caption := 'classe:';
    lbclasse.Transparent := True;
    edclasse.SetParentComponent(Self);
    edclasse.Name := 'edclasse';
    edclasse.Left := 221;
    edclasse.Top := 297;
    edclasse.Width := 200;
    edclasse.Height := 21;
    edclasse.Enabled := True;
    edclasse.TabOrder := 10;
    edclasse.Text := 'edclasse';
    edclasse.DataField := 'classe';
    edclasse.DataSource := DataSource;
    lbpeso_ideal.SetParentComponent(Self);
    lbpeso_ideal.Name := 'lbpeso_ideal';
    lbpeso_ideal.Left := 24;
    lbpeso_ideal.Top := 327;
    lbpeso_ideal.Width := 14;
    lbpeso_ideal.Height := 13;
    lbpeso_ideal.Caption := 'peso_ideal:';
    lbpeso_ideal.Transparent := True;
    edpeso_ideal.SetParentComponent(Self);
    edpeso_ideal.Name := 'edpeso_ideal';
    edpeso_ideal.Left := 221;
    edpeso_ideal.Top := 324;
    edpeso_ideal.Width := 200;
    edpeso_ideal.Height := 21;
    edpeso_ideal.Enabled := True;
    edpeso_ideal.TabOrder := 11;
    edpeso_ideal.Text := 'edpeso_ideal';
    edpeso_ideal.DataField := 'peso_ideal';
    edpeso_ideal.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 354;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 351;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 12;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 381;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 378;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 13;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 408;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 405;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 14;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 435;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 432;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 15;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 462;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 459;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 16;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Plano_Contas1Dataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Plano_Contas1Dataset.SetParentComponent(Self);
    Plano_Contas1Dataset.Name := 'Plano_Contas1Dataset';
    Plano_Contas1Dataset.AfterApplyUpdates := Plano_Contas1DatasetAfterApplyUpdates;
    Plano_Contas1Dataset.EntitySetName := 'Plano_Contas1';
    Plano_Contas1Dataset.Connection := DMConnection.ApiConnection;
    Plano_Contas1Dataset.Left := 176;
    Plano_Contas1Dataset.Top := 8;
    Plano_Contas1Datasetid.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetid.Name := 'Plano_Contas1Datasetid';
    Plano_Contas1Datasetid.FieldName := 'id';
    Plano_Contas1Datasetid.Required := True;
    Plano_Contas1Datasetaliado_id.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetaliado_id.Name := 'Plano_Contas1Datasetaliado_id';
    Plano_Contas1Datasetaliado_id.FieldName := 'aliado_id';
    Plano_Contas1Datasetaliado_id.Required := True;
    Plano_Contas1Datasetdata_base_id.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetdata_base_id.Name := 'Plano_Contas1Datasetdata_base_id';
    Plano_Contas1Datasetdata_base_id.FieldName := 'data_base_id';
    Plano_Contas1Datasetdata_base_id.Required := True;
    Plano_Contas1Datasetnome.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetnome.Name := 'Plano_Contas1Datasetnome';
    Plano_Contas1Datasetnome.FieldName := 'nome';
    Plano_Contas1Datasetnome.Required := True;
    Plano_Contas1Datasetnome.Size := 255;
    Plano_Contas1Datasetclasse.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetclasse.Name := 'Plano_Contas1Datasetclasse';
    Plano_Contas1Datasetclasse.FieldName := 'classe';
    Plano_Contas1Datasetclasse.Required := False;
    Plano_Contas1Datasetclasse.Size := 255;
    Plano_Contas1Datasetpeso_ideal.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetpeso_ideal.Name := 'Plano_Contas1Datasetpeso_ideal';
    Plano_Contas1Datasetpeso_ideal.FieldName := 'peso_ideal';
    Plano_Contas1Datasetpeso_ideal.Required := False;
    Plano_Contas1Datasetcodigo_interno.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetcodigo_interno.Name := 'Plano_Contas1Datasetcodigo_interno';
    Plano_Contas1Datasetcodigo_interno.FieldName := 'codigo_interno';
    Plano_Contas1Datasetcodigo_interno.Required := True;
    Plano_Contas1Datasetexcluido.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetexcluido.Name := 'Plano_Contas1Datasetexcluido';
    Plano_Contas1Datasetexcluido.FieldName := 'excluido';
    Plano_Contas1Datasetexcluido.Required := False;
    Plano_Contas1Datasetinclusao.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetinclusao.Name := 'Plano_Contas1Datasetinclusao';
    Plano_Contas1Datasetinclusao.FieldName := 'inclusao';
    Plano_Contas1Datasetinclusao.Required := False;
    Plano_Contas1Datasetalteracao.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetalteracao.Name := 'Plano_Contas1Datasetalteracao';
    Plano_Contas1Datasetalteracao.FieldName := 'alteracao';
    Plano_Contas1Datasetalteracao.Required := False;
    Plano_Contas1Datasetexclusao.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetexclusao.Name := 'Plano_Contas1Datasetexclusao';
    Plano_Contas1Datasetexclusao.FieldName := 'exclusao';
    Plano_Contas1Datasetexclusao.Required := False;
    XDataClientPlano_Contas1Get.SetParentComponent(Self);
    XDataClientPlano_Contas1Get.Name := 'XDataClientPlano_Contas1Get';
    XDataClientPlano_Contas1Get.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientPlano_Contas1Get, Self, 'OnLoad', 'XDataClientPlano_Contas1GetLoad');
    XDataClientPlano_Contas1Get.Left := 64;
    XDataClientPlano_Contas1Get.Top := 8;
    XDataClientPlano_Contas1Delete.SetParentComponent(Self);
    XDataClientPlano_Contas1Delete.Name := 'XDataClientPlano_Contas1Delete';
    XDataClientPlano_Contas1Delete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientPlano_Contas1Delete, Self, 'OnLoad', 'XDataClientPlano_Contas1DeleteLoad');
    SetEvent(XDataClientPlano_Contas1Delete, Self, 'OnError', 'XDataClientPlano_Contas1DeleteError');
    XDataClientPlano_Contas1Delete.Left := 64;
    XDataClientPlano_Contas1Delete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbclasse.AfterLoadDFMValues;
    edclasse.AfterLoadDFMValues;
    lbpeso_ideal.AfterLoadDFMValues;
    edpeso_ideal.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Plano_Contas1Dataset.AfterLoadDFMValues;
    Plano_Contas1Datasetid.AfterLoadDFMValues;
    Plano_Contas1Datasetaliado_id.AfterLoadDFMValues;
    Plano_Contas1Datasetdata_base_id.AfterLoadDFMValues;
    Plano_Contas1Datasetnome.AfterLoadDFMValues;
    Plano_Contas1Datasetclasse.AfterLoadDFMValues;
    Plano_Contas1Datasetpeso_ideal.AfterLoadDFMValues;
    Plano_Contas1Datasetcodigo_interno.AfterLoadDFMValues;
    Plano_Contas1Datasetexcluido.AfterLoadDFMValues;
    Plano_Contas1Datasetinclusao.AfterLoadDFMValues;
    Plano_Contas1Datasetalteracao.AfterLoadDFMValues;
    Plano_Contas1Datasetexclusao.AfterLoadDFMValues;
    XDataClientPlano_Contas1Get.AfterLoadDFMValues;
    XDataClientPlano_Contas1Delete.AfterLoadDFMValues;
  end;
end;

end.
